import styled from 'styled-components';
import React, { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { Marker } from '../../../../types/marker';
import { AppState } from '../../../../store/interfaces';
import { setMarkerForReplace } from '../../../../store/map/actions';

interface MarkersFormProps {
  markers: Marker[];
}

const Container = styled.div`
  margin-top: 20px;

  input {
    margin-top: 6px;
    margin-right: 8px;
  }

  div {
    margin-bottom: 12px;
    text-align: left;
    display: flex;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const MarkersForm: React.FC<MarkersFormProps> = function ({ markers }) {
  const markerForReplace = useSelector((app: AppState) => app.map.markerForReplace, shallowEqual);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!markerForReplace) {
      dispatch(setMarkerForReplace(markers[0]));
    }
  }, [markerForReplace]);

  return (
    <Container>
      {markers.map((marker, key) => (
        <div key={marker.id}>
          <input
            type="radio"
            name="selectedMarker"
            id={`selectedMarker${marker.id}`}
            value={marker.id}
            defaultChecked={markerForReplace?.id === marker.id || (!markerForReplace && key === 0)}
            onChange={() => {
              dispatch(setMarkerForReplace(marker));
            }}
          />{' '}
          <label htmlFor={`selectedMarker${marker.id}`}>{marker.address}</label>
        </div>
      ))}
    </Container>
  );
};
